<h1 mat-dialog-title>Ajouter un numéro de téléphone</h1>
<form>
  <mat-form-field appearance="fill" class="field">
    <mat-label>Téléphone</mat-label>
    <input [(ngModel)]="telephoneValue" [formControl]="telephone" matInput name="telephone" required type="tel">
    <mat-icon matSuffix>phone</mat-icon>
    <mat-hint>Le numéro de téléphone doit commencer par 06 ou 07</mat-hint>
  </mat-form-field>
</form>
<div class="actions" mat-dialog-actions>
  <button [disabled]="telephone.invalid" [mat-dialog-close]="telephoneValue" class="green-button" mat-button>
    Ajouter
  </button>
  <button (click)="onNoClick()" class="cancel" mat-button>Annuler</button>
</div>
